/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { PlatformList } from '@/components/PlatformList'
import { RefreshListButton } from '@/components/PlatformList/RefreshListButton'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { ALL_PAGES } from '@/constants'
import { LayoutOthers } from '@/layouts/LayoutOthers'
import { useContractDataCloudsColumns } from '@/pages/contract/ContractDataClouds/useContractDataCloudsColumns'
import { CreateDataCloudModal } from '@/pages/dataCloud/DataClouds/CreateDataCloudModal'
import { accountClient } from '@/services/cloudClient/accountClient'
import { createOrders } from '@/utils/createOrders'

export function ContractDataClouds() {
  const { contractId } = useParams()
  const { t } = useTranslation()
  const emitter = PlatformList.useCreateEmitter()
  const columns = useContractDataCloudsColumns()

  const service: TPlatformListService = ({ sorter }, options) => {
    return accountClient.datacloudsApi.listDataClouds(
      {
        contractId,
        ...ALL_PAGES,
        ...createOrders(sorter),
      },
      options,
    )
  }

  return (
    <>
      <LayoutOthers.Alert className="margin-bottom-20">{t('data_cloud_desc')}</LayoutOthers.Alert>
      <PlatformList
        emitter={emitter}
        service={service}
        createTitle={() => (
          <>
            <RefreshListButton />
            <CreateDataCloudModal contractId={contractId} />
          </>
        )}
        columns={columns}
        pagination={false}
      />
    </>
  )
}
